<template>
    <div>
<div class="heading marginzero"><span><b>Amortization Table</b></span></div>
        <div class="card card-height">
            <table id='myQuotesTable' class="table-top table-amort-table" >
     <tr >
       <th class="table-amort-header" >Pmt#</th>
      <th class="table-amort-header" >Opening Balance</th>
      <th class="table-amort-header" >Payment</th>
      <th class="table-amort-header" >Interest</th>
      <th class="table-amort-header" >Principle</th>
      <th class="table-amort-header" >Ending Balance</th>

   </tr>

   <tr class="table-month-row" v-for="(amort,index) in amortization.amortizations" :key="index" >
       <td class="table-month-td" > {{amort.pmtNum}}</td>
       <td class="table-month-td" > {{amort.openingBalance}} </td>
       <td class="table-month-td" > {{amort.payment}} </td>
       <td class="table-month-td" > {{amort.interest}} </td>
       <td class="table-month-td" > {{amort.principle}}</td>
       <td class="table-month-td" > {{amort.endingBalance}}</td>
       </tr>
            </table>
    </div>
    <div id="marginright">
    <input type="button" id="tabbutton" @click="quoteobject.quote.tabIndex--" value="Back">
    <download-excel
        class = "excelbutton"
        name="Amortization.xls"
        title="Amortization Extract"
        worksheet= "Amortization"
        :fetch   = "exportAmortization"
        :fields = "amortization_fields_export"
        type    = "xls">
      Export
    </download-excel>
    </div>
    </div>
</template>
<script>
import amortization from '../js/http-amortization'
import { bus } from '../main'
export default {
  props: ['quoteobject'],
  created () {
    bus.$on('i-got-clicked', data => {
      console.log(data)
      // You can then call your method attached to this component here
      this.getAmortization()
    })
  },
  data () {
    return {
      amortization: [],
      // amortization:[{pmt:1,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:2,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:3,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:4,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:5,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:6,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:7,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:8,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:9,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:10,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:11,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:12,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:13,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:14,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:15,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:16,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:17,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:18,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:19,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:20,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:21,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:22,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:23,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:24,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:25,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"},
      // {pmt:26,openingBalance:"60,000.00",payment:"1,308.77",interest:500.00,principle:808.77,endingbalance:"59,191.23"}],
      amortization_fields_export: {
        'Pmt': 'pmt',
        'Opening Balance': 'openingBalance',
        'Payment': 'payment',
        'Interest': 'interest',
        'Principle': 'principle',
        'Ending Balance': 'endingbalance'
      },
      loanDate: '06/25/2019',
      loanamt: 10.10,
      downpayment: 100,
      interest: 0.09,
      pmtStartDate: '07/05/2019',
      numofpayments: 36

    }
  },
  methods: {
    async exportAmortization () {
      console.log('response')
      const response = this.amortization
      console.log(JSON.stringify(response))
      return response.data
    },
    getAmortization () {
      amortization.get('?', {
        params: {
          loanDate: this.loanDate,
          loanAmt: this.loanamt,
          downPayment: this.downpayment,
          interest: this.interest,
          pmtStartDate: this.pmtStartDate,
          numOfPayments: this.numofpayments
        }
      }).then(response => {
        this.amortization = response.data
        console.log(JSON.stringify(this.amortization.estimations[0]))
      })
    }
  }

}

</script>
<style scoped>
.table-month-header {
 background: #ddd;
 color: black;
   text-align: center;
 font-weight: bold;
border:1px solid black;
 text-align: center;
 font-size: 12px;
 font-family: Verdana, Geneva, Tahoma, sans-serif;
 }
 .table-amort-table{
     font-family: Verdana, Geneva, Tahoma, sans-serif;
 border-collapse: collapse;
 margin: 0px 0px 0px 30px;
 background-color: white;
 width: 85%;
 border-color:"#e3e4e5" ;
 }
 .table-amort-header {
 background: #ddd;
 color: black;
 font-weight: bold;
border:1px solid black;
 text-align: left;
 font-size: 12px;
 font-family: Verdana, Geneva, Tahoma, sans-serif;
 }
 .card-height{
     height:440px;
overflow: scroll;
padding-top:0px
}
.table-top{
   margin-top:3px
 }
 .marginzero{
    margin:0
 }
 #tabbutton{
    float:right;
    color: white;
    padding: 6px 20px;
    background-color: dodgerblue;
    border: 1px solid #ddd;
    margin: 10px 0px 0px 0px;
}
.excelbutton{
  float:right;
  padding-left: 27px;
  padding-right: 15px;
    background-color: dodgerblue;
    border: 1px solid #ddd;
    color: white;
    cursor: pointer;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size : 12px;
    height: 29px;
    margin: 10px 0px 0px 0px;
    width: 100px;
    padding-top: 5px;
}
#marginright{
    margin-right: 10%
}
</style>
